module.exports = __webpack_public_path__ + "static/media/pointer-left.ceb6861c.svg";